
import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import _ from 'underscore';

import { Set } from '~commonInfra/utils/Set';

import { DisableWorkbookAcceleration } from '../../bootstrap/redux/actions/AppActionTypes';
import { requestFailed } from '../../bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '../../codegen/Localize';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { IWorkbookBase } from '../../workbook/models/IWorkbookInfo';
import { DisableWorkbookAccelerationAction } from '../actions/DisableWorkbookAccelerationEntityAction';
import { WorkbookAccelerationActions } from '../actions/WorkbookAccelerationActions';

export function openDisableWorkbookAccelerationDialog(
  workbooks: Set<IWorkbookBase>
): Promise<IResult> {
  return WorkbookAccelerationActions.confirmDisableAcceleration(workbooks.toArray());
}

export function* handleDisableWorkbookAccelerationAction(action: DisableWorkbookAccelerationAction): SagaIterator {
  try {
    const contentDictionaryByType = _.groupBy(action.selectedContent, c => c.contentType);
    const typeArray = Object.keys(contentDictionaryByType);

    if (typeArray.length === 1) {
      const singleContentType = typeArray[0];
      switch (singleContentType) {
        case 'workbook':
          const workbookSet = Set.fromIdItemArray(contentDictionaryByType[singleContentType]);
          try {
            yield call(openDisableWorkbookAccelerationDialog, workbookSet);
          } catch {
            // catches unresolved cancel promise - user presses Escape
            return;
          }
          break;
        default:
          yield put(requestFailed(`${singleContentType} does not support acceleration.`));
          break;
      }
    } else if (typeArray.length > 1) {
      // user selected multiple types of items while data acceleration only supports item type -- workbook
      yield put(requestFailed(`Acceleration only support workbooks.`, Messages.accelerationOnlySupportsWorkbooks()));
    }

  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function* rootDisableWorkbookAccelerationActionSaga(): SagaIterator {
  yield takeEvery(DisableWorkbookAcceleration, handleDisableWorkbookAccelerationAction);
}
